module.exports = __webpack_public_path__ + "media/images/category/event-050544f0951f09c9b4b416994ed4af39.jpg";